//import { any, func, string, bool } from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import TextInput from 'sub_components/Common/BloxTextInput';
import { INPUT_TYPES } from 'utils/Misc/CommonConstants';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const mailImage = `${CDN_URL}common/change-password-modal-icon.svg`;

const emailValidations = [
	{ message: 'Required field', pattern: /.+/ },
	{ message: 'Please enter a valid email address.', pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/ },
];

const ResetPasswordStyle = styled.button`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border: none;
	background-color: transparent;
	color: ${props => props.theme.$DCBLOX_Gray};
	.message-large {
		margin-top: 5px;
		margin-bottom: 5px;
	}
	img {
		width: 100px;
		height: 100px;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const ResetPassword = ({
	id,
	module,
	cypressId,
	customClass,
	onChange,
	email,
	success,
	error,
}) => {
	return (
		<ResetPasswordStyle
			id={id}
			className={`reset-password-wrapper ${customClass} `}
			module={module}
			data-cy={cypressId}
		>
			<div className='reset-password'>
				{!success && !error && (
					<div className='input'>
						<TextInput
							placeholder='EMAIL'
							active={true}
							type={INPUT_TYPES.INPUT}
							label={'EMAIL'}
							name='forgotEmail'
							value={email}
							validations={emailValidations}
							onChange={onChange}
						/>
					</div>
				)}
				{success && !error && (
					<div className='reset-password mail'>
						<img src={mailImage} />
						<div className='message-large heading60'>You've got mail!</div>
						<div className='message body10'>
							We've sent instructions on how to reset your password to your email. Check your inbox
							and follow the link.
						</div>
						<div className='email body10'>{email}</div>
					</div>
				)}
				{error && !success && (
					<div className='reset-password error'>
						<img src={mailImage} />
						<div className='message-large heading60'>Hmm...</div>
						<div className='message body10'>Error sending email. Please try again.</div>
						<div className='email body10'>{email}</div>
					</div>
				)}
			</div>
		</ResetPasswordStyle>
	);
};
